/*
  Arrows for the "what's in the kit" card strip (byla_kit_contents block).
  Shown only on devices with a mouse, and only when the cards overflow.
  RTL aware: "next" moves toward the end of the strip (left in Hebrew).
*/
(function () {
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function setup(viewport) {
    if (viewport.dataset.ready) return;
    viewport.dataset.ready = 'true';

    var list = viewport.querySelector('.byla-kit-contents');
    var prev = viewport.querySelector('.byla-kit-contents__arrow--prev');
    var next = viewport.querySelector('.byla-kit-contents__arrow--next');
    if (!list || !prev || !next) return;

    function rtl() {
      return getComputedStyle(list).direction === 'rtl';
    }

    function step() {
      var card = list.querySelector('.byla-kit-contents__card');
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : list.clientWidth * 0.8;
    }

    function update() {
      var max = list.scrollWidth - list.clientWidth;
      var show = canHover.matches && max > 2;
      prev.hidden = !show;
      next.hidden = !show;
      if (!show) return;
      var position = Math.abs(list.scrollLeft);
      prev.disabled = position < 2;
      next.disabled = position > max - 2;
    }

    function move(direction) {
      var amount = step() * direction;
      list.scrollBy({ left: rtl() ? -amount : amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () {
      move(-1);
    });
    next.addEventListener('click', function () {
      move(1);
    });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (canHover.addEventListener) canHover.addEventListener('change', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);
    update();
  }

  function init() {
    document.querySelectorAll('.byla-kit-contents__viewport').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
